import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import OmsCommentsLogs from './OmsCommentsLogs';
import { omsApi } from 'src/api/omsApis';
import { useParams } from 'react-router';
// import { Document, Page } from 'react-pdf';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';

function InvoiceDetails() {
  const [invoice, setInvoice] = useState({
    _id: '',
    description: '',
    status: '',
    isExternal: null,
    products: [],
    organization: {
      name: '',
      email: '',
    },
    createdBy: {
      name: '',
    },
    createdAt: null,
  });
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const { id } = useParams();

  const fetchInvoiceDetails = async () => {
    try {
      const response = await omsApi.getOmsInvoiceDetailsById(id);

      setInvoice(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleViewPdf = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_OMS_URL}/invoice/invoice_detail?invoiceId=${id}`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/pdf',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch PDF');
      }
      const blob = await response.blob();
      const pdfObjectUrl = URL.createObjectURL(blob);
      setPdfUrl(pdfObjectUrl);
    } catch (error) {
      console.error('Error fetching PDF:', error);
    }
  };

  useEffect(() => {
    fetchInvoiceDetails();
    handleViewPdf();
  }, [id]);

  const handleDownload = async () => {
    try {
      // Fetch the file from the API
      const response = await fetch(
        `${process.env.REACT_APP_OMS_URL}/invoice/invoice_detail?invoiceId=${id}`,
        {
          method: 'POST',
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch file');
      }

      // Read response as Blob
      const blob = await response.blob();

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = url;

      // Specify the file name
      link.setAttribute('download', 'invoice_detail.pdf');

      // Append link to body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error('Error while downloading the file:', error);
    }
  };
  return (
    <Box sx={{ padding: '20px' }}>
      <Box display="flex" justifyContent="space-between">
        <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
          Invoice Details
        </Typography>
        <Button variant="contained" color="secondary" onClick={handleDownload}>
          Download Invoice PDF
        </Button>
      </Box>
      <Grid container spacing={2} style={{ marginTop: '20px' }}>
        <Grid item xs={12} md={6}>
          <Card sx={{ padding: '20px' }}>
            {pdfUrl ? (
              <iframe
                src={`${pdfUrl}#toolbar=0&scrollbar=0`}
                width="100%"
                height="850px"
                title="PDF Preview"
                onLoad={() => {
                  console.log('loaded');
                }}
              />
            ) : (
              <p>Loading PDF...</p>
            )}
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card style={{ borderRadius: '8px' }}>
            <OmsCommentsLogs
              details={invoice}
              commentApiToCall={omsApi?.createInvoiceComment}
              logApiToCall={omsApi.getOrderLogs}
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default InvoiceDetails;
